const CompanyEdit = () => import('@/modules/companies/views/CompanyEdit')

export default [
  {
    path: '/company/edit',
    name: 'companies.edit',
    component: CompanyEdit,
    meta: { requiresAuthentication: true }
  }
]
